"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchQueryParam = void 0;
const react_1 = require("react");
const useLocation_1 = require("root/src/client/v2/browser/hooks/useLocation");
const DESERIALIZATION_ERROR = Symbol('DESERIALIZATION_ERROR');
function useSearchQueryParam({ param, defaultValue, serializerFn, deserializerFn, validator, disableParamsReplace, }) {
    const [value, setValue] = (0, react_1.useState)(() => initStore({ param, defaultValue, deserializerFn, validator }));
    const { search } = (0, useLocation_1.useLocation)();
    (0, react_1.useEffect)(() => {
        if (disableParamsReplace) {
            return;
        }
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set(param, serializer(value, serializerFn));
        window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
    }, [value]);
    (0, react_1.useEffect)(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const urlParam = urlParams.get(param);
        if (urlParam) {
            const v = deserializer(urlParam, deserializerFn);
            setValue(prevState => (typeof v === 'function' ? v(prevState) : v));
        }
        else {
            setValue(null);
        }
    }, [search]);
    const setParamValue = (0, react_1.useCallback)((v) => {
        setValue(prevState => (typeof v === 'function' ? v(prevState) : v));
        const urlParams = new URLSearchParams(window.location.search);
        if (v === null) {
            urlParams.delete(param);
        }
        else {
            urlParams.delete(param, serializer(v, serializerFn));
        }
        if (urlParams.toString().length === 0) {
            window.history.replaceState({}, '', `${window.location.pathname}`);
        }
        else {
            window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
        }
    }, [param]);
    return [
        value,
        setParamValue,
    ];
}
exports.useSearchQueryParam = useSearchQueryParam;
function initStore({ param, deserializerFn, defaultValue, validator }) {
    if (typeof window === 'undefined') {
        return defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const urlParam = urlParams.get(param);
    if (!urlParam) {
        return defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
    }
    const deserializedParam = deserializer(urlParam, deserializerFn);
    if (deserializedParam === DESERIALIZATION_ERROR) {
        return defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
    }
    if (!validator) {
        return deserializedParam;
    }
    return validator(deserializedParam) ? deserializedParam : (defaultValue !== null && defaultValue !== void 0 ? defaultValue : null);
}
function serializer(value, serializerFn) {
    return serializerFn ? serializerFn(value) : String(value);
}
function deserializer(value, deserializerFn) {
    try {
        return deserializerFn ? deserializerFn(value) : value;
    }
    catch (e) {
        return DESERIALIZATION_ERROR;
    }
}
